export default function Header() {
  return (
    <header style={styles.header}>
      <div style={styles.headerContent}>
        <div style={styles.headerLeft}>
          <div style={styles.logo}>🏋️</div>
          <h1 style={styles.title}>لوحة تحكم المدرّب</h1>
        </div>
        
        <div style={styles.headerRight}>
          <div style={styles.notification}>
            <button style={styles.notificationButton}>
              <span style={styles.notificationIcon}>🔔</span>
              <span style={styles.notificationBadge}>3</span>
            </button>
          </div>
          
          <div style={styles.userMenu}>
            <div style={styles.userInfo}>
              <span style={styles.userName}>المدرّب محمد</span>
              <span style={styles.userRole}>مدرب محترف</span>
            </div>
            <div style={styles.userAvatar}>
              <span style={styles.avatarText}>م</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

const styles = {
  header: {
    background: 'linear-gradient(90deg, #2c3e50 0%, #1a2530 100%)',
    color: 'white',
    padding: '0 20px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
    position: 'sticky',
    top: 0,
    zIndex: 100,
    height: '70px',
    display: 'flex',
    alignItems: 'center',
  },
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
  },
  logo: {
    fontSize: '2rem',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    width: '50px',
    height: '50px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 5px 15px rgba(102, 126, 234, 0.4)',
  },
  title: {
    margin: 0,
    fontSize: '1.4rem',
    fontWeight: '700',
    background: 'linear-gradient(to right, #fff, #e0e0e0)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '25px',
  },
  notification: {
    position: 'relative',
  },
  notificationButton: {
    background: 'rgba(255, 255, 255, 0.1)',
    border: 'none',
    color: 'white',
    width: '45px',
    height: '45px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: '1.3rem',
    transition: 'all 0.3s ease',
    position: 'relative',
  },
  notificationIcon: {
    display: 'block',
  },
  notificationBadge: {
    position: 'absolute',
    top: '-5px',
    right: '-5px',
    background: '#f44336',
    color: 'white',
    fontSize: '0.7rem',
    fontWeight: 'bold',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 5px rgba(244, 67, 54, 0.4)',
  },
  userMenu: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    cursor: 'pointer',
  },
  userInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  userName: {
    fontSize: '0.95rem',
    fontWeight: '600',
    marginBottom: '3px',
  },
  userRole: {
    fontSize: '0.8rem',
    color: 'rgba(255, 255, 255, 0.7)',
  },
  userAvatar: {
    width: '45px',
    height: '45px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    boxShadow: '0 5px 15px rgba(76, 175, 80, 0.3)',
  },
  avatarText: {
    color: 'white',
  },
};

// إضافة تأثيرات Hover
if (typeof window !== 'undefined') {
  setTimeout(() => {
    const style = document.createElement('style');
    style.textContent = `
      .notification-btn-hover:hover {
        background: rgba(255, 255, 255, 0.2) !important;
        transform: scale(1.1);
      }
      
      .notification-btn-hover:active {
        transform: scale(0.95);
      }
      
      .user-menu-hover:hover .user-avatar {
        transform: scale(1.1);
      }
      
      .user-menu-hover:hover .user-name {
        color: #667eea;
      }
      
      @media (max-width: 768px) {
        .header-responsive {
          padding: 0 10px !important;
          height: 60px !important;
        }
        
        .header-title-responsive {
          font-size: 1.1rem !important;
        }
        
        .header-logo-responsive {
          width: 40px !important;
          height: 40px !important;
          font-size: 1.5rem !important;
        }
        
        .user-info-responsive {
          display: none !important;
        }
      }
      
      @media (max-width: 480px) {
        .header-title-responsive {
          display: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  }, 100);
}

// إضافة classes للعناصر
const addHeaderEffects = () => {
  if (typeof window !== 'undefined') {
    setTimeout(() => {
      document.querySelectorAll('[style*="notificationButton"]').forEach(el => {
        el.className = (el.className || '') + ' notification-btn-hover';
      });
      document.querySelectorAll('[style*="userMenu"]').forEach(el => {
        el.className = (el.className || '') + ' user-menu-hover';
      });
      
      // إضافة responsive classes
      const header = document.querySelector('header');
      const title = document.querySelector('[style*="title"]');
      const logo = document.querySelector('[style*="logo"]');
      const userInfo = document.querySelector('[style*="userInfo"]');
      
      if (window.innerWidth <= 768) {
        if (header) header.className = (header.className || '') + ' header-responsive';
        if (title) title.className = (title.className || '') + ' header-title-responsive';
        if (logo) logo.className = (logo.className || '') + ' header-logo-responsive';
        if (userInfo) userInfo.className = (userInfo.className || '') + ' user-info-responsive';
      }
    }, 200);
  }
};

// تشغيل التأثيرات عند التحميل
if (typeof window !== 'undefined') {
  addHeaderEffects();
  window.addEventListener('resize', addHeaderEffects);
}